import { Customizations } from 'models'
import { auctionLightTableLabels } from './auctionLightTableLabels'

const futureSalesTableLabels: Customizations = {
  ...auctionLightTableLabels,
  lib: {
    label: 'Réserves à indiquer',
    isDisplayed: true,
  },
}

export { futureSalesTableLabels }
